// src/components/ScrollToTop.jsx
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useSelector } from "react-redux";

export default function ScrollToTop() {
  const { pathname } = useLocation();
  const { search_term,
    CategorySelected } = useSelector((state) => state.store);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname, search_term, CategorySelected]);
  return null;
}